<script>

    import VcPesquisa from "@/components/Form/Pesquisa";
    import VcDatepicker from "@/components/Form/Datepicker";
    import armazenaPedido from "../Analises/services/armazenar_pedido";

    import {PROFUNDIDADE} from '@/util/constants'
    import bus from "../../bus";

    export default {
        components: {
            VcPesquisa,
            VcDatepicker
        },
        computed: {
            extraRemetente() {
                return {
                    fornecedor: 1,
                    cliente: 1
                };
            },
            podeGerarRelatorioInterpretacaoFertilidade(){
                return !(this.interpretacaoFertilidade.formulaAdubo.nitrogenio != '' &&
                    this.interpretacaoFertilidade.formulaAdubo.potassio != '' &&
                    this.interpretacaoFertilidade.formulaAdubo.potassio != '' &&
                    this.interpretacaoFertilidade.prnt != '' &&
                    this.interpretacaoFertilidade.correcaoSoloFosforo != '' &&
                    this.interpretacaoFertilidade.correcaoSoloPotasio != '' &&
                    this.interpretacaoFertilidade.phCorrigir != '');
            }
        },
        data() {
            return {
                tipoPessoa: {value: 'REMETENTE', label: 'Remetente'},
                PROFUNDIDADE: PROFUNDIDADE,
                analiseSolo: {
                    modeloForm: {value: 'Elementos', label: 'Elementos'},
                    tipoForm: {value: 'GRADE', label: 'Grade de amostras'}
                },
                analisePendente: {
                    dataBase: null,
                    buscaRemetentes: true,
                    aplicarDebitoCredito: true
                },
                remetentesAnalisesPendentes: [],
                analiseFinalizada: {
                    dataInicial: null,
                    dataFinal: null,
                    buscaRemetentes: true
                },
                contaReceber: {},
                remetentesAnalisesFinalizadas: [],
                vencimentoBoleto: '',
                relatorioFertilidadeDetalhado: false,
                filtros: [{
                    dataInicial: '',
                    dataFinal: '',
                    profundidade_coleta_inicial: '',
                    profundidade_coleta_final: '',
                    cidade: '',
                    remetente: ''
                }],
                analiseSoloExcel: {},
                interpretacaoFertilidade: {
                    dataInicial: '',
                    dataFinal: '',
                    cidade: '',
                    remetente: '',
                    profundidade_coleta_inicial: '',
                    profundidade_coleta_final: '',
                    formulaAdubo: {
                        nitrogenio: '',
                        fosforo: '',
                        potassio: ''
                    },
                    phCorrigir: {
                        label:"5,5",
                        value:"5.5"
                    },
                    prnt:'',
                    correcaoSoloFosforo:'',
                    correcaoSoloPotasio:'',
                },
                analisesPendentesSebrae: {
                    remetente: '',
                    dataInicial: null,
                    dataFinal: null,
                    possuiAnexo: 0,
                },
            }
        },

        watch: {
            tipoPessoa(){
                this.$set(this.analisePendente, 'remetente', null);
                this.$set(this.analisePendente, 'proprietario', null);
                bus.$emit('limpa-select', true);
            }
        },

        methods: {
            removerFiltro(index) {
                this.filtros.splice(index, 1)
            },

            podeAdicionarFiltro() {
                let retorno = true;
                this.filtros.forEach((filtro, index) => {
                    if (filtro.cidade == '' || filtro.cidade == undefined) {
                        window.swal("Atenção", "Preencha a cidade antes de adicionar outro filtro.", "info")
                        retorno = false;
                    }
                })
                return retorno;
            },

            adicionarNovoFiltro() {
                if (this.filtros.length >= 100) {
                    return window.swal("Atenção", "É possível adicionar no máximo 10 filtros.", "info");
                }

                if (!this.podeAdicionarFiltro()) {
                    return false;
                }

                this.filtros.push({})
            },

            gerarRelatorioEtiquetaGradeAmostraSolo() {
                this.$set(this.analiseSolo, 'modelo', this.analiseSolo.modeloForm.value);
                this.$set(this.analiseSolo, 'tipo', this.analiseSolo.tipoForm.value);
                this.$set(this.analiseSolo, 'primeiraEtiqueta', this.analiseSolo.primeiraEtiqueta);
                let nomePdf = this.analiseSolo.tipoForm.value == 'GRADE' ? "Relatório de grade de solos.pdf" : "Relatório de etiqueta de solos.pdf";
                this.executaPost('api/relatorio/gerar/relatorioEtiquetaGradeAmostrasSolo', this.analiseSolo, nomePdf)
            },

            geraGradeSementes() {
                this.executaPost('api/relatorio/gerar/gerarRelatorioGradeSemente', this.analiseSolo, "Relatório de grades de semente.pdf")
            },

            executaPost(url, data, nomePdf, baixar = true) {
                window.swal({
                    title: "Gerando relatório",
                    imageUrl: require("@/assets/logo.png"),
                    imageWidth: "100px",
                    animation: false,
                    allowOutsideClick: false,
                    onOpen: () => {
                        window.swal.showLoading();

                        this.$http.post(url, data).then((response) => {
                            if (response.data.pdf == null) {
                                return window.swal("Atenção", "Houve um problema ao gerar relatório.<br><br>" + response.data.mensagem, "warning");
                            }

                            if (!response.data.processouEmail && this.analisePendente.envia_email) {
                                return window.swal("Atenção", "Remetente sem e-mail cadastrado, e-mail não enviado.", "warning");
                            }

                            if (baixar) {
                                let a = document.createElement("a");
                                a.href = "data:application/octet-stream;base64," + response.data.pdf;
                                a.download = nomePdf;
                                a.click();
                            }

                            if (response.data.analisesPendentes != undefined) {
                                let analises = Object.values(response.data.analisesPendentes)
                                this.$set(this, 'remetentesAnalisesPendentes', analises)
                            }

                            if (response.data.analisesFinalizadas != undefined && response.data.analisesFinalizadas.length > 0) {
                                this.$set(this, 'remetentesAnalisesFinalizadas', response.data.analisesFinalizadas)
                            }

                            return window.swal("Sucesso", !baixar ? "E-mail enviado com sucesso." : "Relatório gerado com sucesso.", "success");
                        }).catch((response) => {
                            return window.swal("Atenção", "Erro ao gerar relatório. " + response.message, "warning");
                        })
                    }
                });
            },

            executaPostFertilidade() {
                let self = this;
                window.swal({
                    title: "Gerando relatório",
                    imageUrl: require("@/assets/logo.png"),
                    imageWidth: "100px",
                    animation: false,
                    allowOutsideClick: false,
                    onOpen: () => {
                        window.swal.showLoading();

                        let executaRecursivo = function () {
                            self.$http.post('api/relatorio/gerar/avaliacaoFertilidade', {
                                'filtros': self.filtros,
                                'controlaCidades': controlaCidades,
                                'relatorioFertilidadeDetalhado': self.relatorioFertilidadeDetalhado
                            }).then((response) => {
                                if (response.data.pdf == null) {
                                    return window.swal("Atenção", "Houve um problema ao gerar relatório.<br><br>" + response.data.mensagem, "warning");
                                }

                                if (recursivo && response.data.controlaCidades != -1) {
                                    let a = document.createElement("a");
                                    a.href = "data:application/octet-stream;base64," + response.data.pdf;
                                    a.download = 'Relatório de fertilidade ' + response.data.controlaCidades + '.pdf';
                                    a.click();

                                    controlaCidades = response.data.controlaCidades;
                                    executaRecursivo();
                                } else {
                                    if (!recursivo) {
                                        let a = document.createElement("a");
                                        a.href = "data:application/octet-stream;base64," + response.data.pdf;
                                        a.download = 'Relatório de fertilidade.pdf';
                                        a.click();
                                    }

                                    return window.swal("Sucesso", "Relatório gerado com sucesso.", "success");
                                }
                            }).catch((response) => {
                                return window.swal("Atenção", "Erro ao gerar relatório. " + response.message, "warning");
                            })
                        }

                        let recursivo = (self.filtros[0].cidade != '' ? false : true);
                        let controlaCidades = 0;
                        executaRecursivo();
                    }
                });
            },

            verificaSenha() {
                window.swal({
                    title: 'Informe a senha para emitir o relatório.',
                    input: 'password',
                    showCancelButton: true,
                    confirmButtonText: 'Confirmar',
                    cancelButtonText: 'Cancelar',
                    showLoaderOnConfirm: true,
                    preConfirm: (senha) => {
                        if (senha == this.$store.state.Empresa.configuracao.senha) {
                            return true
                        }
                        window.swal.showValidationMessage('Senha inválida.')
                        return false
                    },
                    allowOutsideClick: () => !window.swal.isLoading()
                }).then((result) => {
                    if (result.dismiss != undefined && (result.dismiss == "cancel" || result.dismiss == "esc" || result.dismiss == "overlay")) {
                        $('#inicialAmostraSolosEtiqueta').addClass('active')
                        $('#inicialReceber').removeClass('active')
                        $('#inicialAmostraSolosEtiqueta').click()
                    }
                })
            },

            geraRelatorioPendentes() {
                remetentesAnalisesFinalizadas: []

                this.$set(this.analisePendente, 'dataBaseListagem', this.analisePendente.dataBase)
                this.$set(this.analisePendente, 'tipoPessoa', this.tipoPessoa.value)

                this.executaPost('api/relatorio/gerar/relatorioAnalisePendente', this.analisePendente, 'Relatório de análises pendentes.pdf')
            },

            enviarEmailFinalizadas(indexAnalise) {
                let data = {
                    'remetente': this.remetentesAnalisesFinalizadas[indexAnalise].remetente,
                    'dataInicial': this.analiseFinalizada.dataInicialListagem,
                    'dataFinal': this.analiseFinalizada.dataFinalListagem,
                    'envia_email': true
                }

                this.$set(this.remetentesAnalisesFinalizadas[indexAnalise], 'processou', true)
                this.executaPost('api/relatorio/gerar/relatorioAnaliseFinalizada', data, 'Relatório de análises finalizadas.pdf', false)
            },

            geraRelatorioFinalizadas() {
                this.remetentesAnalisesPendentes = []

                this.$set(this.analiseFinalizada, 'dataInicialListagem', this.analiseFinalizada.dataInicial)
                this.$set(this.analiseFinalizada, 'dataFinalListagem', this.analiseFinalizada.dataFinal)

                this.executaPost('api/relatorio/gerar/relatorioAnaliseFinalizada', this.analiseFinalizada, 'Relatório de análises finalizadas.pdf')
            },

            selecionouPessoa(proprietarioRemetente, tipo) {
                if (tipo == 'FINALIZADAP') {
                    this.$set(this.analiseFinalizada, 'proprietario', proprietarioRemetente)
                } else if (tipo == 'FINALIZADAA') {
                    this.$set(this.analiseFinalizada, 'arrendatario', proprietarioRemetente)
                } else if (tipo == 'FINALIZADAR') {
                    this.$set(this.analiseFinalizada, 'remetente', proprietarioRemetente)
                } else if (tipo == 'RECEBER') {
                    this.$set(this.contaReceber, 'remetente_id', proprietarioRemetente.id)
                } else if (tipo == 'PROPRIETARIO') {
                    this.$set(this.analisePendente, 'proprietario', proprietarioRemetente)
                } else {
                    this.$set(this.analisePendente, 'remetente', proprietarioRemetente)
                    this.$set(this.analisePendente, 'aplicarDebitoCredito', false)

                    if (proprietarioRemetente.creditos_debitos_aberto.length > 0) {
                        window.swal({
                            title: "Aplicar créditos e débitos",
                            text: "Deseja aplicar créditos e débitos?",
                            type: "warning",
                            showCancelButton: true,
                            confirmButtonColor: "#3085d6",
                            cancelButtonColor: "#d33",
                            confirmButtonText: "Sim",
                            cancelButtonText: "Não"
                        }).then(result => {
                            if (result.value) {
                                this.$set(this.analisePendente, 'aplicarDebitoCredito', true)
                            }
                        });
                    }
                }
                this.remetentesAnalisesFinalizadas = [];
                this.remetentesAnalisesPendentes = [];
            },

            async processar(index) {
                let remetente = this.remetentesAnalisesPendentes[index]

                if (remetente.pagamentoBoleto && (this.vencimentoBoleto == '' || this.vencimentoBoleto == null)) {
                    return window.swal("Atenção", "Selecione uma data de vencimento do boleto para continuar.", "warning");
                }

                if(remetente.analises != undefined){
                    await remetente.analises.forEach((analise, index) => {
                        remetente.analises[index].data_vencimento = this.vencimentoBoleto
                        remetente.analises[index].forma_pagamento = remetente.pagamentoBoleto ? 'BOLETO' : 'FATURADA'
                        remetente.analises[index].boleto = this.tipoPessoa.value == 'PROPRIETARIO' ? 'PROPRIETARIO' : (remetente.pagamentoBoleto ? 'REMETENTE' : remetente.analises[index].boleto)
                        remetente.analises[index].emitir_nota = remetente.emitirNfse
                        remetente.analises[index].pessoa_id = remetente.remetente_id
                    })
                }

                if(remetente.analisesExternas != undefined){
                    await remetente.analisesExternas.forEach((analise, index) => {
                        remetente.analisesExternas[index].data_vencimento = this.vencimentoBoleto
                        remetente.analisesExternas[index].forma_pagamento = remetente.pagamentoBoleto ? 'BOLETO' : 'FATURADA'
                        remetente.analisesExternas[index].boleto = 'REMETENTE'
                        remetente.analisesExternas[index].emitir_nota = remetente.emitirNfse
                        remetente.analisesExternas[index].pessoa_id = remetente.remetente_id
                    })
                }

                window.swal({
                    title: "Processando analises",
                    imageUrl: require("@/assets/logo.png"),
                    imageWidth: "100px",
                    animation: false,
                    allowOutsideClick: false,
                    onOpen: () => {
                        window.swal.showLoading();
                        let listaAnalises = [];
                        if(remetente.analises != undefined){
                            listaAnalises = listaAnalises.concat(remetente.analises)
                        }
                        if(remetente.analisesExternas != undefined){
                            listaAnalises = listaAnalises.concat(remetente.analisesExternas)
                        }
                        armazenaPedido.enviar(listaAnalises, true, remetente.creditosDebitos).then(async (res) => {
                            if (res.data.erro == 1) {
                                return window.swal('Atenção!', 'Não foi possível realizar processo, tente novamente!', 'warning');
                            }

                            if (remetente.pagamentoBoleto) {
                                await this.$http.get("api/analises/get-boleto/" + (remetente.analises != undefined ? remetente.analises[0].id : remetente.analisesExternas[0].id), {'enviaEmail': false, 'externa': remetente.analisesExternas != undefined}).then(response => {
                                    let a = document.createElement("a");
                                    a.href = "data:application/octet-stream;base64," + response.data.pdf;
                                    a.download = "Boleto agrupamento de analises.pdf";
                                    a.click();
                                });
                            }

                            if (remetente.emitirNfse) {
                                await this.$http.get("api/analises/get-nfse/" + (remetente.analises != undefined ? remetente.analises[0].id : remetente.analisesExternas[0].id), {'enviaEmail': false, 'externa': remetente.analisesExternas != undefined}).then(response2 => {
                                    if (response2.data.pdf != null) {
                                        let a2 = document.createElement("a");
                                        a2.href = "data:application/octet-stream;base64," + response2.data.pdf;
                                        a2.download = "NFS-e agrupamento de analises.pdf";
                                        a2.click();
                                    }
                                });
                            }

                            this.$set(this.remetentesAnalisesPendentes[index], 'processou', true)
                            this.$set(this.remetentesAnalisesPendentes[index], 'pedidoId', res.data.pedido.id)
                            if (remetente.enviarEmail) {
                                await this.enviarEmailPendentes(index)
                            }
                            return window.swal('Sucesso!', 'Processamento finalizado!', 'success');
                        })
                    }
                });
            },

            async enviarEmailPendentes(index) {
                let remetente = this.remetentesAnalisesPendentes[index]
                window.swal({
                    title: "Enviando",
                    imageUrl: require("@/assets/logo.png"),
                    imageWidth: "100px",
                    animation: false,
                    allowOutsideClick: false,
                    onOpen: () => {
                        window.swal.showLoading();
                        this.$http.post('api/relatorio/gerar/relatorioAnalisePendenteEnviaEmail', {
                            'enviarNota': remetente.processou ? remetente.emitirNfse : false,
                            'enviarBoleto': remetente.processou ? remetente.pagamentoBoleto : false,
                            'remetenteId': remetente.remetente_id,
                            'aplicarDebitoCredito': this.analisePendente.aplicarDebitoCredito,
                            'pedidoId': remetente.pedidoId != undefined ? remetente.pedidoId : null
                        }).then((response) => {
                            this.$set(this.remetentesAnalisesPendentes[index], 'enviouEmail', response.data.enviouEmail)
                            if (!response.data.enviouEmail) {
                                return window.swal('Atenção!', 'Não foi possível enviar e-mail, sem e-mail no cadastro, tente novamente!' + response.data.mensagem, 'warning');
                            }
                            return window.swal('Sucesso!', 'E-mail enviado com sucesso!', 'success');
                        })
                    }
                })
            },

            controlaFormaPagamento(index, boleto = true) {
                this.$set(this.remetentesAnalisesPendentes[index], 'pagamentoDinheiro', !boleto)
                this.$set(this.remetentesAnalisesPendentes[index], 'pagamentoBoleto', boleto)
            },

            async geraExcel() {
                let analiseSoloExcel = this.analiseSoloExcel

                if (analiseSoloExcel.numeroRegistroInicialAno == undefined || analiseSoloExcel.numeroRegistroFinalAno == undefined || analiseSoloExcel.numeroRegistroInicial == undefined || analiseSoloExcel.numeroRegistroFinal == undefined ||
                    analiseSoloExcel.numeroRegistroInicialAno == '' || analiseSoloExcel.numeroRegistroFinalAno == '' || analiseSoloExcel.numeroRegistroInicial == '' || analiseSoloExcel.numeroRegistroFinal == '') {
                    return window.swal("Atenção", "Registros preenchidos incorretamente, informe os mesmos.", "warning");
                }

                if (analiseSoloExcel.numeroRegistroInicialAno > analiseSoloExcel.numeroRegistroFinalAno || analiseSoloExcel.numeroRegistroInicial > analiseSoloExcel.numeroRegistroFinal) {
                    return window.swal("Atenção", "Registros preenchidos incorretamente, registro incial tem que ser menor que o final.", "warning");
                }

                window.swal({
                    title: "Gerando Excel",
                    imageUrl: require("@/assets/logo.png"),
                    imageWidth: "100px",
                    animation: false,
                    allowOutsideClick: false,
                    onOpen: () => {
                        window.swal.showLoading();
                        this.$http.post('api/relatorio/gerar/geraResultadoExcelRegistros', analiseSoloExcel).then((response) => {
                            if (response.data.arquivo == null) {
                                return window.swal("Atenção", "Houve um problema ao gerar excel.<br><br>" + response.data.mensagem, "warning");
                            }

                            let a = document.createElement("a");
                            a.href = response.data.arquivo;
                            a.download = "Resultado analises " + analiseSoloExcel.numeroRegistroInicial + " / " + analiseSoloExcel.numeroRegistroInicialAno + " - " + analiseSoloExcel.numeroRegistroFinal + " / " + analiseSoloExcel.numeroRegistroFinalAno + ".xlsx";
                            a.click();

                            return window.swal("Sucesso", "Excel gerado com sucesso.", "success");
                        }).catch((response) => {
                            return window.swal("Atenção", "Erro ao gerar excel. " + response.message, "warning");
                        })
                    }
                });
            },

            executaPostInterpretacaoFertilidade() {
                this.executaPost(
                    'api/relatorio/gerar/relatorioInterpretacaoFertilidade',
                    this.interpretacaoFertilidade,
                    'Relatório de interpretação de fertilidade.pdf');
            },
        },
        mounted() {
            let data = new Date();
            data.setDate(data.getDate() + 30);
            this.$set(this, "vencimentoBoleto", data.toISOString().substr(0, 10));

            this.analisesPendentesSebrae.possuiAnexo = {value: '0', label: "Não"}

            this.$store.dispatch("setConfiguracao");
            this.$store.dispatch('setTitle', 'Relatórios');
        }
    }
</script>

<template>
    <div class="margin-top-10">
        <ul class="nav nav-tabs">
            <li class="active"><a data-toggle="tab"
                                  id="inicialAmostraSolosEtiqueta"
                                  href="#amostraSolosEtiqueta">Grade
                de amostras / Etiqueta de
                Solos</a></li>
            <li><a data-toggle="tab"
                   href="#gradeSementes">Grade de sementes</a></li>    
            <li><a data-toggle="tab"
                   href="#analisesPendente">Análises
                pendentes</a></li>
            <li><a data-toggle="tab"
                   href="#analisesFinalizada">Análises
                finalizadas</a></li>
            <li><a data-toggle="tab"
                   href="#resultadoExcel">Resultado
                análise excel</a></li>
            <li><a data-toggle="tab"
                   id="inicialReceber"
                   @click="verificaSenha"
                   href="#receber">Contas à receber
                (análises à prazo)</a></li>
            <li>
                <a data-toggle="tab"
                   href="#avaliacao">Avaliação
                    de fertilidade</a></li>
            <li>
                <a data-toggle="tab"
                   href="#interpretacaoFertilidade">Interpretação de fertilidade</a></li>
            <li>
                <a data-toggle="tab"
                   href="#analisesPendentesSebrae">Análises pendentes Sebrae</a></li>
        </ul>
        <div class="tab-content">
            <div id="amostraSolosEtiqueta" class="tab-pane fade"
                 :class="{'in active': parseInt($store.state.Auth.user.permissao_empresa.gerente) || parseInt($store.state.Auth.user.permissao_empresa.master)}">
                <div class="panel panel-default margin-top-10">
                    <div class="panel-body">

                        <div class="row">
                            <div class="col-xs-12 col-sm-4">
                                <div class="form-group">
                                    <label>Tipo</label>
                                    <v-select
                                            v-model="analiseSolo.tipoForm"
                                            :options="[
                                          {value: 'GRADE',label: 'Grade de amostras'},
                                          {value: 'ETIQUETA',label: 'Etiquetas'}
                                        ]"
                                    ></v-select>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-xs-12 col-sm-4">
                                <div class="form-group">
                                    <label>Número registro inicial</label>
                                    <div class="row">
                                        <div class="col-xs-6 col-sm-4">
                                            <input type="text" class="form-control"
                                                   v-model="analiseSolo.numeroRegistroInicial" size="10"/>
                                        </div>
                                        <div class="col-xs-6 col-sm-4">
                                            <the-mask mask="####" type="text" :masked="true"
                                                      v-model="analiseSolo.numeroRegistroInicialAno"
                                                      class="form-control"></the-mask>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-xs-12 col-sm-4">
                                <div class="form-group">
                                    <label>Número registro final</label>
                                    <div class="row">
                                        <div class="col-xs-6 col-sm-4">
                                            <input type="text" class="form-control"
                                                   v-model="analiseSolo.numeroRegistroFinal"/>
                                        </div>
                                        <div class="col-xs-6 col-sm-4">
                                            <the-mask mask="####" type="text" :masked="true"
                                                      v-model="analiseSolo.numeroRegistroFinalAno"
                                                      class="form-control"></the-mask>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-xs-12 col-sm-4">
                                <div class="form-group">
                                    <label>Data inicial</label>
                                    <vc-datepicker v-model="analiseSolo.dataInicial"
                                                   :value="analiseSolo.dataInicial"
                                                   autocomplete="off"/>
                                </div>
                            </div>
                            <div class="col-xs-12 col-sm-4">
                                <div class="form-group">
                                    <label>Data final</label>
                                    <vc-datepicker v-model="analiseSolo.dataFinal" :value="analiseSolo.dataFinal"
                                                   autocomplete="off"/>
                                </div>
                            </div>
                        </div>

                        <div class="row" v-if="analiseSolo.tipoForm.value == 'ETIQUETA'">
                            <div class="col-xs-12 col-sm-4">
                                <div class="form-group">
                                    <label>Início da impressão</label> <br>
                                    <table class="table table-bordered table-striped table-hover tabelaInicio">
                                        <tbody>
                                        <tr>
                                            <td width="25%"><label class="radio-inline"><input type="radio"
                                                                                               v-model="analiseSolo.primeiraEtiqueta"
                                                                                               value="1"> 1</label>
                                            </td>
                                            <td width="25%"><label class="radio-inline"><input type="radio"
                                                                                               v-model="analiseSolo.primeiraEtiqueta"
                                                                                               value="2"> 2</label>
                                            </td>
                                            <td width="25%"><label class="radio-inline"><input type="radio"
                                                                                               v-model="analiseSolo.primeiraEtiqueta"
                                                                                               value="3"> 3</label>
                                            </td>
                                            <td width="25%"><label class="radio-inline"><input type="radio"
                                                                                               v-model="analiseSolo.primeiraEtiqueta"
                                                                                               value="4"> 4</label>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td><label class="radio-inline"><input type="radio"
                                                                                   v-model="analiseSolo.primeiraEtiqueta"
                                                                                   value="5"> 2</label></td>
                                            <td><label class="radio-inline"><input type="radio"
                                                                                   v-model="analiseSolo.primeiraEtiqueta"
                                                                                   value="6">&nbsp;</label></td>
                                            <td><label class="radio-inline"><input type="radio"
                                                                                   v-model="analiseSolo.primeiraEtiqueta"
                                                                                   value="7">&nbsp;</label></td>
                                            <td><label class="radio-inline"><input type="radio"
                                                                                   v-model="analiseSolo.primeiraEtiqueta"
                                                                                   value="8">&nbsp;</label></td>
                                        </tr>
                                        <tr>
                                            <td><label class="radio-inline"><input type="radio"
                                                                                   v-model="analiseSolo.primeiraEtiqueta"
                                                                                   value="9"> 3</label></td>
                                            <td><label class="radio-inline"><input type="radio"
                                                                                   v-model="analiseSolo.primeiraEtiqueta"
                                                                                   value="10">&nbsp;</label></td>
                                            <td><label class="radio-inline"><input type="radio"
                                                                                   v-model="analiseSolo.primeiraEtiqueta"
                                                                                   value="11">&nbsp;</label></td>
                                            <td><label class="radio-inline"><input type="radio"
                                                                                   v-model="analiseSolo.primeiraEtiqueta"
                                                                                   value="12">&nbsp;</label></td>
                                        </tr>
                                        <tr>
                                            <td><label class="radio-inline"><input type="radio"
                                                                                   v-model="analiseSolo.primeiraEtiqueta"
                                                                                   value="13"> 4</label></td>
                                            <td><label class="radio-inline"><input type="radio"
                                                                                   v-model="analiseSolo.primeiraEtiqueta"
                                                                                   value="14">&nbsp;</label></td>
                                            <td><label class="radio-inline"><input type="radio"
                                                                                   v-model="analiseSolo.primeiraEtiqueta"
                                                                                   value="15">&nbsp;</label></td>
                                            <td><label class="radio-inline"><input type="radio"
                                                                                   v-model="analiseSolo.primeiraEtiqueta"
                                                                                   value="16">&nbsp;</label></td>
                                        </tr>
                                        <tr>
                                            <td><label class="radio-inline"><input type="radio"
                                                                                   v-model="analiseSolo.primeiraEtiqueta"
                                                                                   value="17"> 5</label></td>
                                            <td><label class="radio-inline"><input type="radio"
                                                                                   v-model="analiseSolo.primeiraEtiqueta"
                                                                                   value="18">&nbsp;</label></td>
                                            <td><label class="radio-inline"><input type="radio"
                                                                                   v-model="analiseSolo.primeiraEtiqueta"
                                                                                   value="19">&nbsp;</label></td>
                                            <td><label class="radio-inline"><input type="radio"
                                                                                   v-model="analiseSolo.primeiraEtiqueta"
                                                                                   value="20">&nbsp;</label></td>
                                        </tr>
                                        <tr>
                                            <td><label class="radio-inline"><input type="radio"
                                                                                   v-model="analiseSolo.primeiraEtiqueta"
                                                                                   value="21"> 6</label></td>
                                            <td><label class="radio-inline"><input type="radio"
                                                                                   v-model="analiseSolo.primeiraEtiqueta"
                                                                                   value="22">&nbsp;</label></td>
                                            <td><label class="radio-inline"><input type="radio"
                                                                                   v-model="analiseSolo.primeiraEtiqueta"
                                                                                   value="23">&nbsp;</label></td>
                                            <td><label class="radio-inline"><input type="radio"
                                                                                   v-model="analiseSolo.primeiraEtiqueta"
                                                                                   value="24">&nbsp;</label></td>
                                        </tr>
                                        <tr>
                                            <td><label class="radio-inline"><input type="radio"
                                                                                   v-model="analiseSolo.primeiraEtiqueta"
                                                                                   value="25"> 7</label></td>
                                            <td><label class="radio-inline"><input type="radio"
                                                                                   v-model="analiseSolo.primeiraEtiqueta"
                                                                                   value="26">&nbsp;</label></td>
                                            <td><label class="radio-inline"><input type="radio"
                                                                                   v-model="analiseSolo.primeiraEtiqueta"
                                                                                   value="27">&nbsp;</label></td>
                                            <td><label class="radio-inline"><input type="radio"
                                                                                   v-model="analiseSolo.primeiraEtiqueta"
                                                                                   value="28">&nbsp;</label></td>
                                        </tr>
                                        <tr>
                                            <td><label class="radio-inline"><input type="radio"
                                                                                   v-model="analiseSolo.primeiraEtiqueta"
                                                                                   value="29"> 8</label></td>
                                            <td><label class="radio-inline"><input type="radio"
                                                                                   v-model="analiseSolo.primeiraEtiqueta"
                                                                                   value="30">&nbsp;</label></td>
                                            <td><label class="radio-inline"><input type="radio"
                                                                                   v-model="analiseSolo.primeiraEtiqueta"
                                                                                   value="31">&nbsp;</label></td>
                                            <td><label class="radio-inline"><input type="radio"
                                                                                   v-model="analiseSolo.primeiraEtiqueta"
                                                                                   value="32">&nbsp;</label></td>
                                        </tr>
                                        <tr>
                                            <td><label class="radio-inline"><input type="radio"
                                                                                   v-model="analiseSolo.primeiraEtiqueta"
                                                                                   value="33"> 9</label></td>
                                            <td><label class="radio-inline"><input type="radio"
                                                                                   v-model="analiseSolo.primeiraEtiqueta"
                                                                                   value="34">&nbsp;</label></td>
                                            <td><label class="radio-inline"><input type="radio"
                                                                                   v-model="analiseSolo.primeiraEtiqueta"
                                                                                   value="35">&nbsp;</label></td>
                                            <td><label class="radio-inline"><input type="radio"
                                                                                   v-model="analiseSolo.primeiraEtiqueta"
                                                                                   value="36">&nbsp;</label></td>
                                        </tr>
                                        <tr>
                                            <td><label class="radio-inline"><input type="radio"
                                                                                   v-model="analiseSolo.primeiraEtiqueta"
                                                                                   value="37"> 10</label></td>
                                            <td><label class="radio-inline"><input type="radio"
                                                                                   v-model="analiseSolo.primeiraEtiqueta"
                                                                                   value="38">&nbsp;</label></td>
                                            <td><label class="radio-inline"><input type="radio"
                                                                                   v-model="analiseSolo.primeiraEtiqueta"
                                                                                   value="39">&nbsp;</label></td>
                                            <td><label class="radio-inline"><input type="radio"
                                                                                   v-model="analiseSolo.primeiraEtiqueta"
                                                                                   value="40">&nbsp;</label></td>
                                        </tr>
                                        <tr>
                                            <td><label class="radio-inline"><input type="radio"
                                                                                   v-model="analiseSolo.primeiraEtiqueta"
                                                                                   value="41"> 11</label></td>
                                            <td><label class="radio-inline"><input type="radio"
                                                                                   v-model="analiseSolo.primeiraEtiqueta"
                                                                                   value="42">&nbsp;</label></td>
                                            <td><label class="radio-inline"><input type="radio"
                                                                                   v-model="analiseSolo.primeiraEtiqueta"
                                                                                   value="43">&nbsp;</label></td>
                                            <td><label class="radio-inline"><input type="radio"
                                                                                   v-model="analiseSolo.primeiraEtiqueta"
                                                                                   value="44">&nbsp;</label></td>
                                        </tr>
                                        <tr>
                                            <td><label class="radio-inline"><input type="radio"
                                                                                   v-model="analiseSolo.primeiraEtiqueta"
                                                                                   value="45"> 12</label></td>
                                            <td><label class="radio-inline"><input type="radio"
                                                                                   v-model="analiseSolo.primeiraEtiqueta"
                                                                                   value="46">&nbsp;</label></td>
                                            <td><label class="radio-inline"><input type="radio"
                                                                                   v-model="analiseSolo.primeiraEtiqueta"
                                                                                   value="47">&nbsp;</label></td>
                                            <td><label class="radio-inline"><input type="radio"
                                                                                   v-model="analiseSolo.primeiraEtiqueta"
                                                                                   value="48">&nbsp;</label></td>
                                        </tr>
                                        <tr>
                                            <td><label class="radio-inline"><input type="radio"
                                                                                   v-model="analiseSolo.primeiraEtiqueta"
                                                                                   value="49"> 13</label></td>
                                            <td><label class="radio-inline"><input type="radio"
                                                                                   v-model="analiseSolo.primeiraEtiqueta"
                                                                                   value="50">&nbsp;</label></td>
                                            <td><label class="radio-inline"><input type="radio"
                                                                                   v-model="analiseSolo.primeiraEtiqueta"
                                                                                   value="51">&nbsp;</label></td>
                                            <td><label class="radio-inline"><input type="radio"
                                                                                   v-model="analiseSolo.primeiraEtiqueta"
                                                                                   value="52">&nbsp;</label></td>
                                        </tr>
                                        <tr>
                                            <td><label class="radio-inline"><input type="radio"
                                                                                   v-model="analiseSolo.primeiraEtiqueta"
                                                                                   value="53"> 14</label></td>
                                            <td><label class="radio-inline"><input type="radio"
                                                                                   v-model="analiseSolo.primeiraEtiqueta"
                                                                                   value="54">&nbsp;</label></td>
                                            <td><label class="radio-inline"><input type="radio"
                                                                                   v-model="analiseSolo.primeiraEtiqueta"
                                                                                   value="55">&nbsp;</label></td>
                                            <td><label class="radio-inline"><input type="radio"
                                                                                   v-model="analiseSolo.primeiraEtiqueta"
                                                                                   value="56">&nbsp;</label></td>
                                        </tr>
                                        <tr>
                                            <td><label class="radio-inline"><input type="radio"
                                                                                   v-model="analiseSolo.primeiraEtiqueta"
                                                                                   value="57"> 15</label></td>
                                            <td><label class="radio-inline"><input type="radio"
                                                                                   v-model="analiseSolo.primeiraEtiqueta"
                                                                                   value="58">&nbsp;</label></td>
                                            <td><label class="radio-inline"><input type="radio"
                                                                                   v-model="analiseSolo.primeiraEtiqueta"
                                                                                   value="59">&nbsp;</label></td>
                                            <td><label class="radio-inline"><input type="radio"
                                                                                   v-model="analiseSolo.primeiraEtiqueta"
                                                                                   value="60">&nbsp;</label></td>
                                        </tr>
                                        <tr>
                                            <td><label class="radio-inline"><input type="radio"
                                                                                   v-model="analiseSolo.primeiraEtiqueta"
                                                                                   value="61"> 16</label></td>
                                            <td><label class="radio-inline"><input type="radio"
                                                                                   v-model="analiseSolo.primeiraEtiqueta"
                                                                                   value="62">&nbsp;</label></td>
                                            <td><label class="radio-inline"><input type="radio"
                                                                                   v-model="analiseSolo.primeiraEtiqueta"
                                                                                   value="63">&nbsp;</label></td>
                                            <td><label class="radio-inline"><input type="radio"
                                                                                   v-model="analiseSolo.primeiraEtiqueta"
                                                                                   value="64">&nbsp;</label></td>
                                        </tr>
                                        <tr>
                                            <td><label class="radio-inline"><input type="radio"
                                                                                   v-model="analiseSolo.primeiraEtiqueta"
                                                                                   value="65"> 17</label></td>
                                            <td><label class="radio-inline"><input type="radio"
                                                                                   v-model="analiseSolo.primeiraEtiqueta"
                                                                                   value="66">&nbsp;</label></td>
                                            <td><label class="radio-inline"><input type="radio"
                                                                                   v-model="analiseSolo.primeiraEtiqueta"
                                                                                   value="67">&nbsp;</label></td>
                                            <td><label class="radio-inline"><input type="radio"
                                                                                   v-model="analiseSolo.primeiraEtiqueta"
                                                                                   value="68">&nbsp;</label></td>
                                        </tr>
                                        <tr>
                                            <td><label class="radio-inline"><input type="radio"
                                                                                   v-model="analiseSolo.primeiraEtiqueta"
                                                                                   value="69"> 18</label></td>
                                            <td><label class="radio-inline"><input type="radio"
                                                                                   v-model="analiseSolo.primeiraEtiqueta"
                                                                                   value="70">&nbsp;</label></td>
                                            <td><label class="radio-inline"><input type="radio"
                                                                                   v-model="analiseSolo.primeiraEtiqueta"
                                                                                   value="71">&nbsp;</label></td>
                                            <td><label class="radio-inline"><input type="radio"
                                                                                   v-model="analiseSolo.primeiraEtiqueta"
                                                                                   value="72">&nbsp;</label></td>
                                        </tr>
                                        <tr>
                                            <td><label class="radio-inline"><input type="radio"
                                                                                   v-model="analiseSolo.primeiraEtiqueta"
                                                                                   value="73"> 19</label></td>
                                            <td><label class="radio-inline"><input type="radio"
                                                                                   v-model="analiseSolo.primeiraEtiqueta"
                                                                                   value="74">&nbsp;</label></td>
                                            <td><label class="radio-inline"><input type="radio"
                                                                                   v-model="analiseSolo.primeiraEtiqueta"
                                                                                   value="75">&nbsp;</label></td>
                                            <td><label class="radio-inline"><input type="radio"
                                                                                   v-model="analiseSolo.primeiraEtiqueta"
                                                                                   value="76">&nbsp;</label></td>
                                        </tr>
                                        <tr>
                                            <td><label class="radio-inline"><input type="radio"
                                                                                   v-model="analiseSolo.primeiraEtiqueta"
                                                                                   value="77"> 20</label></td>
                                            <td><label class="radio-inline"><input type="radio"
                                                                                   v-model="analiseSolo.primeiraEtiqueta"
                                                                                   value="78">&nbsp;</label></td>
                                            <td><label class="radio-inline"><input type="radio"
                                                                                   v-model="analiseSolo.primeiraEtiqueta"
                                                                                   value="79">&nbsp;</label></td>
                                            <td><label class="radio-inline"><input type="radio"
                                                                                   v-model="analiseSolo.primeiraEtiqueta"
                                                                                   value="80">&nbsp;</label></td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                        <div class="row" v-if="analiseSolo.tipoForm.value == 'GRADE'">
                            <div class="col-xs-12 col-sm-4">
                                <div class="form-group">
                                    <label>Modelo</label>
                                    <v-select
                                            v-model="analiseSolo.modeloForm"
                                            :options="[
                                          {value: 'Elementos',label: 'Elementos'},
                                          {value: 'Resultado',label: 'Resultado'}
                                        ]"
                                    ></v-select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <button class="btn btn-success" @click="gerarRelatorioEtiquetaGradeAmostraSolo">
                    Gerar relatório
                </button>
            </div>

            <div id="gradeSementes" class="tab-pane fade">
                <div class="panel panel-default margin-top-10">
                    <div class="panel-body">
                        <div class="row">
                            <div class="col-xs-12 col-sm-4">
                                <div class="form-group">
                                    <label>Número registro inicial</label>
                                    <div class="row">
                                        <div class="col-xs-6 col-sm-4">
                                            <input type="text" class="form-control"
                                                   v-model="analiseSolo.numeroRegistroInicial" size="10"/>
                                        </div>
                                        <div class="col-xs-6 col-sm-4">
                                            <the-mask mask="####" type="text" :masked="true"
                                                      v-model="analiseSolo.numeroRegistroInicialAno"
                                                      class="form-control"></the-mask>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-xs-12 col-sm-4">
                                <div class="form-group">
                                    <label>Número registro final</label>
                                    <div class="row">
                                        <div class="col-xs-6 col-sm-4">
                                            <input type="text" class="form-control"
                                                   v-model="analiseSolo.numeroRegistroFinal"/>
                                        </div>
                                        <div class="col-xs-6 col-sm-4">
                                            <the-mask mask="####" type="text" :masked="true"
                                                      v-model="analiseSolo.numeroRegistroFinalAno"
                                                      class="form-control"></the-mask>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-xs-12 col-sm-4">
                                <div class="form-group">
                                    <label>Data inicial</label>
                                    <vc-datepicker v-model="analiseSolo.dataInicial"
                                                   :value="analiseSolo.dataInicial"
                                                   autocomplete="off"/>
                                </div>
                            </div>
                            <div class="col-xs-12 col-sm-4">
                                <div class="form-group">
                                    <label>Data final</label>
                                    <vc-datepicker v-model="analiseSolo.dataFinal" :value="analiseSolo.dataFinal"
                                                   autocomplete="off"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <button class="btn btn-success" @click="geraGradeSementes">
                    Gerar relatório
                </button>
            </div>

            <div id="analisesPendente"
                 class="tab-pane fade">
                <div class="panel panel-default margin-top-10">
                    <div class="panel-body">
                        <div class="row">
                            <div class="col-xs-12 col-sm-4">
                                <div class="form-group">
                                    <label for="">Tipo de pessoa</label>
                                    <v-select
                                        v-model="tipoPessoa"
                                        :options="[{value: 'REMETENTE', label: 'Remetente'}, {value: 'PROPRIETARIO', label: 'Proprietário'}]">
                                    </v-select>
                                </div>
                            </div>
                            <div class="col-xs-12 col-sm-4" v-if="tipoPessoa.value == 'REMETENTE'">
                                <div class="form-group">
                                    <vc-pesquisa
                                            @input="(pessoa) => selecionouPessoa(pessoa, 'REMETENTE')"
                                            label="Remetente"
                                            :extra="{fornecedor: 1, cliente: 1}"
                                            url-busca="api/pessoas/pesquisa"
                                            limpaSelect="true"
                                            :selecionado-config="{label: 'nomerazao_social', campo: 'id'}"
                                            :campos-table="[ {'label' : 'Nome', 'campo' : 'nomerazao_social'}, {'label' : 'CPF/CNPJ', 'campo' : 'cpfcnpj'}]">
                                    </vc-pesquisa>
                                </div>
                            </div>

                            <div class="col-xs-12 col-sm-4" v-if="tipoPessoa.value == 'PROPRIETARIO'">
                                <div class="form-group">
                                    <vc-pesquisa
                                            @input="(pessoa) => selecionouPessoa(pessoa, 'PROPRIETARIO')"
                                            label="Proprietário"
                                            :extra="{tecnico_agricola: 1, cliente: 1}"
                                            url-busca="api/pessoas/pesquisa"
                                            limpaSelect="true"
                                            :selecionado-config="{label: 'nomerazao_social', campo: 'id'}"
                                            :campos-table="[ {'label' : 'Nome', 'campo' : 'nomerazao_social'}, {'label' : 'CPF/CNPJ', 'campo' : 'cpfcnpj'}]">
                                    </vc-pesquisa>
                                </div>
                            </div>

                            <div class="col-xs-12 col-sm-4">
                                <div class="form-group">
                                    <label>Data base</label>
                                    <vc-datepicker v-model="analisePendente.dataBase"
                                                   :value="analisePendente.dataBase"
                                                   autocomplete="off" @input="remetentesAnalisesPendentes = []"/>
                                </div>
                            </div>

                            <div v-if="remetentesAnalisesPendentes.length > 0" class="col-xs-12 col-sm-4">
                                <div class="form-group">
                                    <label>Vencimento do(s) boleto(s)</label>
                                    <vc-datepicker v-model="vencimentoBoleto"/>
                                </div>
                            </div>
                        </div>

                        <div class="row" v-if="remetentesAnalisesPendentes.length > 0 && (parseInt($store.state.Auth.user.permissao_empresa.gerente) || parseInt($store.state.Auth.user.permissao_empresa.master))">
                            <div class="col-sm-12">
                                <table class="table dataTable table-striped">
                                    <thead>
                                    <tr role="row">
                                        <th width="60%">{{ tipoPessoa.value }}</th>
                                        <th width="40%" class="text-center">Ações</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(analise, indexAnalise) in remetentesAnalisesPendentes">
                                        <td>{{ analise.nome }} <br>
                                            <span v-if="analise.creditosDebitos != null && analise.creditosDebitos.credito > 0">Valor do crédito R$ {{ analise.creditosDebitos.credito | formatMoney }}</span><br>
                                            <span v-if="analise.creditosDebitos != null && analise.creditosDebitos.debito > 0">Valor do débito R$ {{ analise.creditosDebitos.debito | formatMoney }}</span>

                                            <div style="padding-top: 25px;">
                                                <div class="col-xs-6 col-sm-2">
                                                    <div class="form-group">
                                                        <label class="switch switch-success"><input type="checkbox"
                                                                                                    :disabled="analise.processou"
                                                                                                    @click="controlaFormaPagamento(indexAnalise, false)"
                                                                                                    v-model="analise.pagamentoDinheiro"><span></span></label>&nbsp;<b>Dinheiro</b>
                                                    </div>
                                                </div>

                                                <div class="col-xs-6 col-sm-2">
                                                    <div class="form-group">
                                                        <label class="switch switch-success"><input type="checkbox"
                                                                                                    @click="controlaFormaPagamento(indexAnalise, true)"
                                                                                                    :disabled="analise.processou"
                                                                                                    v-model="analise.pagamentoBoleto"><span></span></label>&nbsp;<b>Boleto</b>
                                                    </div>
                                                </div>

                                                <div class="col-xs-6 col-sm-2">
                                                    <div class="form-group">
                                                        <label class="switch switch-success"><input type="checkbox"
                                                                                                    :disabled="analise.processou"
                                                                                                    v-model="analise.emitirNfse"><span></span></label>&nbsp;<b>NFS-e</b>
                                                    </div>
                                                </div>

                                                <div class="col-xs-6 col-sm-2">
                                                    <div class="form-group">
                                                        <label class="switch switch-success"><input type="checkbox"
                                                                                                    :disabled="analise.processou"
                                                                                                    v-model="analise.enviarEmail"><span></span></label>&nbsp;<b>E-mail</b>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                        <td class="text-center linha-botoes-processar">
                                            <button :class="{'btn btn-info': !analise.processou, 'btn btn-success': analise.processou}"
                                                    @click="processar(indexAnalise)"
                                                    :disabled="analise.processou || (!analise.pagamentoBoleto && !analise.pagamentoDinheiro)"
                                                    title="Processar"><i class="fa fa-copy"></i> Processar
                                            </button>&emsp;
                                            <button :class="{'btn btn-info': !analise.enviouEmail, 'btn btn-success': analise.enviouEmail}"
                                                    @click="enviarEmailPendentes(indexAnalise)"
                                                    title="Enviar e-mail"><i class="fa fa-envelope"></i>
                                            </button>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                    </div>
                </div>
                <button class="btn btn-success" @click="geraRelatorioPendentes">
                    Gerar relatório
                </button>
            </div>

            <div id="resultadoExcel"
                 class="tab-pane fade">
                <div class="panel panel-default margin-top-10">
                    <div class="panel-body">
                        <div class="row">
                            <div class="col-xs-12 col-sm-4">
                                <div class="form-group">
                                    <label>Número registro inicial</label>
                                    <div class="row">
                                        <div class="col-xs-6 col-sm-4">
                                            <the-mask mask="##########" type="text" :masked="true"
                                                      v-model="analiseSoloExcel.numeroRegistroInicial"
                                                      class="form-control"></the-mask>
                                        </div>
                                        <div class="col-xs-6 col-sm-4">
                                            <the-mask mask="####" type="text" :masked="true"
                                                      v-model="analiseSoloExcel.numeroRegistroInicialAno"
                                                      class="form-control"></the-mask>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-xs-12 col-sm-4">
                                <div class="form-group">
                                    <label>Número registro final</label>
                                    <div class="row">
                                        <div class="col-xs-6 col-sm-4">
                                            <input type="text" class="form-control"
                                                   v-model="analiseSoloExcel.numeroRegistroFinal"/>
                                        </div>
                                        <div class="col-xs-6 col-sm-4">
                                            <the-mask mask="####" type="text" :masked="true"
                                                      v-model="analiseSoloExcel.numeroRegistroFinalAno"
                                                      class="form-control"></the-mask>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <button class="btn btn-success" @click="geraExcel">
                    Gerar relatório
                </button>
            </div>

            <div id="receber" class="tab-pane fade">
                <div class="panel panel-default margin-top-10">
                    <div class="panel-body">

                        <div class="row">
                            <div class="col-xs-12 col-sm-4">
                                <div class="form-group">
                                    <vc-pesquisa
                                            @input="(pessoa) => selecionouPessoa(pessoa, 'RECEBER')"
                                            label="Remetente"
                                            :extra="{fornecedor: 1, cliente: 1}"
                                            url-busca="api/pessoas/pesquisa"
                                            :selecionado-config="{label: 'nomerazao_social', campo: 'id'}"
                                            :campos-table="[ {'label' : 'Nome', 'campo' : 'nomerazao_social'}, {'label' : 'CPF/CNPJ', 'campo' : 'cpfcnpj'}]">
                                    </vc-pesquisa>
                                </div>
                            </div>

                            <div class="col-xs-12 col-sm-4">
                                <div class="form-group">
                                    <label>Data de lançamento inicial</label>
                                    <vc-datepicker v-model="contaReceber.dataInicial"
                                                   :value="contaReceber.dataInicial"
                                                   autocomplete="off"/>
                                </div>
                            </div>
                            <div class="col-xs-12 col-sm-4">
                                <div class="form-group">
                                    <label>Data de lançamento final</label>
                                    <vc-datepicker v-model="contaReceber.dataFinal" :value="contaReceber.dataFinal"
                                                   autocomplete="off"/>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <button class="btn btn-success"
                        @click="executaPost('api/relatorio/gerar/relatorioContasReceber', contaReceber, 'Relatório de contas receber.pdf')">
                    Gerar relatório
                </button>
            </div>

            <div id="analisesFinalizada"
                 class="tab-pane fade">
                <div class="panel panel-default margin-top-10">
                    <div class="panel-body">

                        <div class="row">
                            <div class="col-xs-12 col-sm-4">
                                <div class="form-group">
                                    <vc-pesquisa
                                            @input="(pessoa) => selecionouPessoa(pessoa, 'FINALIZADAR')"
                                            label="Remetente"
                                            :extra="{fornecedor: 1, cliente: 1}"
                                            url-busca="api/pessoas/pesquisa"
                                            :selecionado-config="{label: 'nomerazao_social', campo: 'id'}"
                                            :campos-table="[ {'label' : 'Nome', 'campo' : 'nomerazao_social'}, {'label' : 'CPF/CNPJ', 'campo' : 'cpfcnpj'}]">
                                    </vc-pesquisa>
                                </div>
                            </div>

                            <div class="col-xs-12 col-sm-4">
                                <div class="form-group">
                                    <vc-pesquisa
                                            @input="(pessoa) => selecionouPessoa(pessoa, 'FINALIZADAP')"
                                            label="Proprietário"
                                            :extra="{fornecedor: 0 ,cliente: 1}"
                                            url-busca="api/pessoas/pesquisa"
                                            :selecionado-config="{label: 'nomerazao_social', campo: 'id'}"
                                            :campos-table="[ {'label' : 'Nome', 'campo' : 'nomerazao_social'}, {'label' : 'CPF/CNPJ', 'campo' : 'cpfcnpj'}]">
                                    </vc-pesquisa>
                                </div>
                            </div>

                            <div class="col-xs-12 col-sm-4">
                                <div class="form-group">
                                    <vc-pesquisa
                                            @input="(pessoa) => selecionouPessoa(pessoa, 'FINALIZADAA')"
                                            label="Arrendatário"
                                            :extra="{fornecedor: 0 ,cliente: 1}"
                                            url-busca="api/pessoas/pesquisa"
                                            :selecionado-config="{label: 'nomerazao_social', campo: 'id'}"
                                            :campos-table="[ {'label' : 'Nome', 'campo' : 'nomerazao_social'}, {'label' : 'CPF/CNPJ', 'campo' : 'cpfcnpj'}]">
                                    </vc-pesquisa>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-xs-12 col-sm-4">
                                <div class="form-group">
                                    <label>Data inicial</label>
                                    <vc-datepicker v-model="analiseFinalizada.dataInicial"
                                                   :value="analiseFinalizada.dataInicial" autocomplete="off"
                                                   @input="remetentesAnalisesFinalizadas = []"/>
                                </div>
                            </div>
                            <div class="col-xs-12 col-sm-4">
                                <div class="form-group">
                                    <label>Data final</label>
                                    <vc-datepicker v-model="analiseFinalizada.dataFinal"
                                                   :value="analiseFinalizada.dataFinal" autocomplete="off"
                                                   @input="remetentesAnalisesFinalizadas = []"/>
                                </div>
                            </div>
                        </div>

                        <div class="row" v-if="remetentesAnalisesFinalizadas.length > 0">
                            <div class="col-sm-12">
                                <table class="table dataTable">
                                    <thead>
                                    <tr role="row">
                                        <th width="19%">Remetente</th>
                                        <th width="15%" class="text-center">Ações</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr role="row" class="even"
                                        v-for="(analise, indexAnalise) in remetentesAnalisesFinalizadas">
                                        <td>{{ analise.nomerazao_social }} {{ analise.cpfcnpj != '' ? ' (' +
                                            analise.cpfcnpj + ')' : '' }}
                                        </td>
                                        <td class="text-center lista-analises">
                                            <button :class="{'btn btn-info': !analise.processou, 'btn btn-success': analise.processou}"
                                                    @click="enviarEmailFinalizadas(indexAnalise)"
                                                    title="Enviar e-mail"><i class="fa fa-envelope"></i>
                                            </button>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                    </div>
                </div>

                <button class="btn btn-success" @click="geraRelatorioFinalizadas">
                    Gerar relatório
                </button>
            </div>

            <div id="avaliacao" class="tab-pane fade" :class="{'in active': !parseInt($store.state.Auth.user.permissao_empresa.master) && !parseInt($store.state.Auth.user.permissao_empresa.gerente)}">
                <div class="row" style="margin: 20px 0 20px 0;">
                    <div class="col-xs-2 col-sm-2">
                        <button type="button" class="btn btn-primary btn-sm" @click="adicionarNovoFiltro">Adicionar outro filtro
                        </button>
                    </div>
                    
                    <div class="col-xs-10 col-sm-10">
                        <div class="form-group">
                            <label class="switch switch-success"><input type="checkbox" name="relatorioDetalhado" v-model="relatorioFertilidadeDetalhado"><span></span></label>&nbsp;Relatório por quantidade de analises
                        </div>
                    </div>
                </div>

                <div v-for="(filtro, index) in filtros">
                    <div class="panel panel-default margin-top-10">
                        <div class="panel-heading" v-if="index != 0">
                            <button type="button" class="btn btn-danger btn-sm"
                                    @click="removerFiltro(index)" title="Remover filtro">
                                Remover
                            </button>
                        </div>
                        <div class="panel-body">
                            <div class="col-xs-12 col-sm-4">
                                <div class="form-group">
                                    <label>Data inicial</label>
                                    <vc-datepicker v-model="filtro.dataInicial" :value="filtro.dataInicial"
                                                   autocomplete="off"/>
                                </div>
                            </div>
                            <div class="col-xs-12 col-sm-4">
                                <div class="form-group">
                                    <label>Data final</label>
                                    <vc-datepicker v-model="filtro.dataFinal" :value="filtro.dataFinal"
                                                   autocomplete="off"/>
                                </div>
                            </div>
                            <div class="col-xs-12 col-sm-4">
                                <vc-pesquisa
                                        @input="(cidade) => filtro.cidade =  cidade"
                                        :selecionado="filtro.cidade"
                                        label="Cidade"
                                        nome-input="cidadeId"
                                        :selecionado-config="{label : 'nome', campo : 'id'}"
                                        url-busca="api/cidades/pesquisa"
                                        :campos-table="[ {'label' : 'Nome', 'campo' : 'nome'}, {'label' : 'Código IBGE', 'campo' : 'codigo_ibge'}]">
                                </vc-pesquisa>
                            </div>
                            <div class="col-xs-12 col-sm-4">
                                <vc-pesquisa
                                        @input=" remetente => filtro.remetente = remetente"
                                        :selecionado="filtro.remetente"
                                        :extra="extraRemetente"
                                        label="Remetente"
                                        nome-input="remetente_id"
                                        url-busca="api/pessoas/pesquisa"
                                        :selecionado-config="{label: 'nomerazao_social', campo: 'id'}"
                                        :campos-table="[ {'label' : 'Nome', 'campo' : 'nomerazao_social'}, {'label' : 'CPF/CNPJ', 'campo' : 'cpfcnpj'}]">
                                </vc-pesquisa>
                            </div>
                            <div class="col-xs-12 col-sm-4">
                                <div class="form-group">
                                    <label>Profundidade inicial da coleta</label>
                                    <v-select
                                            v-model="filtro.profundidade_coleta_inicial"
                                            :options="PROFUNDIDADE">
                                    </v-select>
                                </div>
                            </div>
                            <div class="col-xs-12 col-sm-4">
                                <div class="form-group">
                                    <label>Profundidade final da coleta</label>
                                    <v-select
                                            v-model="filtro.profundidade_coleta_final"
                                            :options="PROFUNDIDADE">
                                    </v-select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <button class="btn btn-success"
                        @click="executaPostFertilidade()">
                    Gerar relatório
                </button>
            </div>

            <div id="interpretacaoFertilidade" class="tab-pane">

                <div>
                    <div class="panel panel-default margin-top-10">
                        <div class="panel-body">
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="col-xs-12 col-sm-4">
                                        <div class="form-group">
                                            <label>Data inicial</label>
                                            <vc-datepicker v-model="interpretacaoFertilidade.dataInicial" :value="interpretacaoFertilidade.dataInicial"
                                                           autocomplete="off"/>
                                        </div>
                                    </div>
                                    <div class="col-xs-12 col-sm-4">
                                        <div class="form-group">
                                            <label>Data final</label>
                                            <vc-datepicker v-model="interpretacaoFertilidade.dataFinal" :value="interpretacaoFertilidade.dataFinal"
                                                           autocomplete="off"/>
                                        </div>
                                    </div>
                                    <div class="col-xs-12 col-sm-4">
                                        <vc-pesquisa
                                            @input="(cidade) => interpretacaoFertilidade.cidade =  cidade"
                                            :selecionado="interpretacaoFertilidade.cidade"
                                            label="Cidade"
                                            nome-input="cidadeId"
                                            :selecionado-config="{label : 'nome', campo : 'id'}"
                                            url-busca="api/cidades/pesquisa"
                                            :campos-table="[ {'label' : 'Nome', 'campo' : 'nome'}, {'label' : 'Código IBGE', 'campo' : 'codigo_ibge'}]">
                                        </vc-pesquisa>
                                    </div>
                                    <div class="col-xs-12 col-sm-4">
                                        <vc-pesquisa
                                            @input=" remetente => interpretacaoFertilidade.remetente = remetente"
                                            :selecionado="interpretacaoFertilidade.remetente"
                                            :extra="extraRemetente"
                                            label="Remetente"
                                            nome-input="remetente_id"
                                            url-busca="api/pessoas/pesquisa"
                                            :selecionado-config="{label: 'nomerazao_social', campo: 'id'}"
                                            :campos-table="[ {'label' : 'Nome', 'campo' : 'nomerazao_social'}, {'label' : 'CPF/CNPJ', 'campo' : 'cpfcnpj'}]">
                                        </vc-pesquisa>
                                    </div>
                                    <div class="col-xs-12 col-sm-4">
                                        <div class="form-group">
                                            <label>Profundidade inicial da coleta</label>
                                            <v-select
                                                v-model="interpretacaoFertilidade.profundidade_coleta_inicial"
                                                :options="PROFUNDIDADE">
                                            </v-select>
                                        </div>
                                    </div>
                                    <div class="col-xs-12 col-sm-4">
                                        <div class="form-group">
                                            <label>Profundidade final da coleta</label>
                                            <v-select
                                                v-model="interpretacaoFertilidade.profundidade_coleta_final"
                                                :options="PROFUNDIDADE">
                                            </v-select>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="block">
                                        <div class="block-title">
                                            <h3>Fórmula do adubo</h3>
                                        </div>
                                        <div class="row">
                                            <div class="col-xs-12 col-sm-4">
                                                <div class="form-group">
                                                    <label>Nitrogênio (N) <i class="text-danger" title="Campo obrigatório">*</i></label>
                                                    <the-mask :mask="'###########'" type="text" v-model="interpretacaoFertilidade.formulaAdubo.nitrogenio" class="form-control"></the-mask>
                                                </div>
                                            </div>

                                            <div class="col-xs-12 col-sm-4">
                                                <div class="form-group">
                                                    <label>Fósforo (P) <i class="text-danger" title="Campo obrigatório">*</i></label>
                                                    <the-mask :mask="'###########'" type="text" v-model="interpretacaoFertilidade.formulaAdubo.fosforo" class="form-control"></the-mask>
                                                </div>
                                            </div>

                                            <div class="col-xs-12 col-sm-4">
                                                <div class="form-group">
                                                    <label>Potássio (K) <i class="text-danger" title="Campo obrigatório">*</i></label>
                                                    <the-mask :mask="'###########'" type="text" v-model="interpretacaoFertilidade.formulaAdubo.potassio" class="form-control"></the-mask>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-sm-12">

                                    <div class="col-xs-12 col-sm-4">
                                        <div class="form-group">
                                            <label>pH a corrigir <i class="text-danger" title="Campo obrigatório">*</i></label>
                                            <v-select
                                                v-model="interpretacaoFertilidade.phCorrigir"
                                                :options="[
                                            {value: '5.5',label: '5,5'},
                                            {value: '6.0',label: '6,0'},
                                            {value: '6.5',label: '6,5'}
                                            ]">
                                            </v-select>
                                        </div>
                                    </div>

                                    <div class="col-xs-12 col-sm-4">
                                        <div class="form-group">
                                            <label>PRNT <i class="text-danger" title="Campo obrigatório">*</i></label>
                                            <the-mask :mask="'###########'" type="text" v-model="interpretacaoFertilidade.prnt" class="form-control"></the-mask>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-sm-12">
                                    <div class="col-xs-12 col-sm-4">
                                        <div class="form-group">
                                            <label>Correção de solo fósforo <i class="text-danger" title="Campo obrigatório">*</i></label>
                                            <v-select
                                                v-model="interpretacaoFertilidade.correcaoSoloFosforo"
                                                :options="[
                                            {value: '1',label: 'Super simples'},
                                            {value: '2',label: 'Super triplo'},
                                            {value: '3',label: 'MAP'},
                                            {value: '4',label: 'DAP'},
                                            {value: '5',label: 'Fosfato natural'}]">
                                            </v-select>
                                        </div>
                                    </div>

                                    <div class="col-xs-12 col-sm-4">
                                        <div class="form-group">
                                            <label>Correção de solo potásio <i class="text-danger" title="Campo obrigatório">*</i></label>
                                            <v-select
                                                v-model="interpretacaoFertilidade.correcaoSoloPotasio"
                                                :options="[
                                            {value: '1' ,label: 'Cloreto de potássio'},
                                            {value: '2' ,label: 'Sulfato de potássio'},
                                            {value: '3' ,label: 'Nitrato de potássio'}]">
                                            </v-select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <button class="btn btn-success" :disabled="podeGerarRelatorioInterpretacaoFertilidade"
                        @click="executaPostInterpretacaoFertilidade()">
                    Gerar relatório
                </button>
            </div>

            <div id="analisesPendentesSebrae" class="tab-pane">
                <div>
                    <div class="panel panel-default margin-top-10">
                        <div class="panel-body">
                            <div class="row">
                                <div class="col-xs-12 col-sm-4">
                                    <vc-pesquisa
                                        @input=" remetente => analisesPendentesSebrae.remetente = remetente"
                                        :selecionado="analisesPendentesSebrae.remetente"
                                        :extra="extraRemetente"
                                        label="Remetente"
                                        nome-input="remetente_id"
                                        url-busca="api/pessoas/pesquisa"
                                        :selecionado-config="{label: 'nomerazao_social', campo: 'id'}"
                                        :campos-table="[ {'label' : 'Nome', 'campo' : 'nomerazao_social'}, {'label' : 'CPF/CNPJ', 'campo' : 'cpfcnpj'}]">
                                    </vc-pesquisa>
                                </div>

                                <div class="col-xs-12 col-sm-4">
                                    <div class="form-group">
                                        <label>Número registro inicial</label>
                                        <div class="row">
                                            <div class="col-xs-6 col-sm-4">
                                                <the-mask mask="##########" type="text" :masked="true"
                                                          v-model="analisesPendentesSebrae.numeroRegistroInicial"
                                                          class="form-control"></the-mask>
                                            </div>
                                            <div class="col-xs-6 col-sm-4">
                                                <the-mask mask="####" type="text" :masked="true"
                                                          v-model="analisesPendentesSebrae.numeroRegistroInicialAno"
                                                          class="form-control"></the-mask>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-xs-12 col-sm-4">
                                    <div class="form-group">
                                        <label>Número registro final</label>
                                        <div class="row">
                                            <div class="col-xs-6 col-sm-4">
                                                <input type="text" class="form-control"
                                                       v-model="analisesPendentesSebrae.numeroRegistroFinal"/>
                                            </div>
                                            <div class="col-xs-6 col-sm-4">
                                                <the-mask mask="####" type="text" :masked="true"
                                                          v-model="analisesPendentesSebrae.numeroRegistroFinalAno"
                                                          class="form-control"></the-mask>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-xs-12 col-sm-4">
                                    <div class="form-group">
                                        <label>Data inicial</label>
                                        <vc-datepicker v-model="analisesPendentesSebrae.dataInicial" :value="analisesPendentesSebrae.dataInicial"
                                                       autocomplete="off"/>
                                    </div>
                                </div>
                                <div class="col-xs-12 col-sm-4">
                                    <div class="form-group">
                                        <label>Data final</label>
                                        <vc-datepicker v-model="analisesPendentesSebrae.dataFinal" :value="analisesPendentesSebrae.dataFinal"
                                                       autocomplete="off"/>
                                    </div>
                                </div>

                                <div class="col-xs-12 col-sm-4">
                                    <div class="form-group">
                                        <label>Possuir anexo</label>
                                        <v-select
                                            v-model="analisesPendentesSebrae.possuiAnexo"
                                            :options="[
                                                  {value: '0',label: 'Não'},
                                                  {value: '1',label: 'Sim'}
                                            ]"></v-select>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <button class="btn btn-success"
                        @click="executaPost('api/relatorio/gerar/relatorioAnalisePendenteSebrae', analisesPendentesSebrae, 'Relatório de Análises Pendentes Sebrae.pdf')">
                    Gerar relatório
                </button>
            </div>
        </div>
    </div>

</template>

<style>
    .tabelaInicio tr td {
        padding-top: 0px !important;
        padding-bottom: 0px !important;
    }

    .linha-botoes-processar {
        padding-top: 50px !important;
    }
</style>
